import React, { Fragment, useContext } from 'react';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from 'react-google-maps';
import { compose, withProps, withHandlers, withStateHandlers } from 'recompose';
import HotelMapMarkerCluster from './ListingPageMap';
import HotelMapMarkerSingle from './SinglePageMap';
import { MAPSTYLE } from './MapStyle';
import MarkerClusterer from 'react-google-maps/lib/components/addons/MarkerClusterer';
import { GlobalContext } from 'context/GlobalProvider';

const countryLocations = {
  Belgium: {
    location: {
      lat: 50.503887, lng: 4.469936
    }, 
    zoom: 7
  },
  Portugal: {
    location: {
      lat: 39.399872, lng: -8.224454
    }, 
    zoom: 6
  },
  France: {
    location: {
      lat: 46.227638, lng: 2.213749
    }, 
    zoom: 6
  },
  Croatia: {
    location: {
      lat: 45.1, lng: 15.2000001
    }, 
    zoom: 7
  },
  Israel: {
    location: {
      lat: 32.046051, lng: 34.851612
    }, 
    zoom: 8
  },
  "Canary Islands": {
    location: {
      lat: 28.2915637, lng: -16.0
    }, 
    zoom: 8
  },
  Netherlands: {
    location: {
      lat: 52.132633, lng: 5.291266
    }, 
    zoom: 8
  },
  Spain: {
    location: {
      lat: 40.463667, lng: -3.74922
    }, 
    zoom: 6
  },
  Italy: {
    location: {
      lat: 41.87194, lng: 12.56738
    }, 
    zoom: 6
  },
  UK: {
    location: {
      lat: 55.378051, lng: -3.435973
    }, 
    zoom: 6
  },
  Germany: {
    location: {
      lat: 51.165691, lng: 10.451526
    }, 
    zoom: 6
  },
  Ireland: {
    location: {
      lat: 53.3656698, lng: -9.341381
    }, 
    zoom: 7
  },
  Greece: {
    location: {
      lat: 39.074208, lng: 23.824312
    }, 
    zoom: 7
  }
}

const defaultCenter = {
  location: {
    lat: 45.000000, lng: 20.000000
  }, 
  zoom: 4.5
};

export const MapLoadingElement = mapLoadingProps => {
  const { height } = mapLoadingProps;

  return <div style={{ height: height }} />;
};

const MapDataProcessingEnv = compose(
  withProps(({ height = 400 }) => ({
    googleMapURL: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    loadingElement: <MapLoadingElement height='100%' />,
    containerElement: (
      <div style={{ height: `${height}px`, marginBottom: '20px' }} />
    ),
    mapElement: <div style={{ height: `${height}px` }} />
  })),
  withHandlers({
    onMarkerClustererClick: () => markerClusterer => {
      const clickedMarkers = markerClusterer.getMarkers();
      console.log(`Current clicked markers length: ${clickedMarkers.length}`);
      console.log(clickedMarkers);
    }
  }),
  withStateHandlers(
    ({ isOpenedTooltip = false, location = {} }) => {
      const isOpen = isOpenedTooltip;
      const markerIndex = isOpenedTooltip ? location.id : null;
      return { isOpen, markerIndex };
    },
    {
      infoWindowToggle:
        ({ isOpen }) =>
        index => {
          return {
            isOpen: !isOpen,
            markerIndex: index
          };
        }
    }
  ),
  withScriptjs,
  withGoogleMap
);

const MapLayout = props => {
  const { mapLocation } = useContext(GlobalContext);
  const { multiple, marinas, country } = props;

  const isCountryChosen = country && country !== 'anywhere';
  const chosenMarinaLocation = mapLocation.lat ? {lat: +mapLocation.lat, lng: +mapLocation.lng} : null;
  const centerLocation = isCountryChosen ? countryLocations[country].location : defaultCenter.location;
  const zoom = isCountryChosen ? countryLocations[country].zoom : defaultCenter.zoom;

  return (
    <Fragment>
      {multiple ? (
        <GoogleMap
          styles={MAPSTYLE}
          zoom={chosenMarinaLocation ? 8 : zoom}
          center={chosenMarinaLocation || centerLocation}
        >
          <MarkerClusterer
            onClick={props.onMarkerClustererClick}
            averageCenter
            defaultEnableRetinaIcons={true}
            gridSize={60}
          >
            <HotelMapMarkerCluster marinas={marinas} {...props} />
          </MarkerClusterer>
        </GoogleMap>
      ) : (
        <GoogleMap
          styles={MAPSTYLE}
          defaultZoom={defaultCenter.zoom}
          defaultCenter={defaultCenter.location}
        >
          <HotelMapMarkerSingle {...props} />
        </GoogleMap>
      )}
    </Fragment>
  );
};

export const MapDataProcessing = MapDataProcessingEnv(MapLayout);

const Map = props => {
  return <Fragment>{props.children}</Fragment>;
};

export default Map;
